module.exports = __webpack_public_path__ + "static/media/LadyBoneDemonTowerEXTA0031_design_clean_v001.2292749b.webp";